var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUserProfile03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-profile-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.003 8.6095C15.8491 8.6095 14.103 10.3556 14.103 12.5095C14.103 14.6634 15.8491 16.4095 18.003 16.4095C20.157 16.4095 21.9031 14.6634 21.9031 12.5095C21.9031 10.3556 20.157 8.6095 18.003 8.6095ZM11.103 12.5095C11.103 8.69874 14.1923 5.6095 18.003 5.6095C21.8138 5.6095 24.9031 8.69874 24.9031 12.5095C24.9031 16.3203 21.8138 19.4095 18.003 19.4095C14.1923 19.4095 11.103 16.3203 11.103 12.5095ZM3.5731 28.8382C5.93343 24.9013 10.9102 22.5238 18.003 22.5238C25.0959 22.5238 30.0726 24.9013 32.433 28.8382C32.859 29.5488 32.6283 30.4701 31.9178 30.8961C31.2073 31.322 30.2859 31.0914 29.86 30.3808C28.2441 27.6856 24.5062 25.5238 18.003 25.5238C11.4999 25.5238 7.76202 27.6856 6.14611 30.3808C5.72014 31.0914 4.79882 31.322 4.08831 30.8961C3.37779 30.4701 3.14712 29.5488 3.5731 28.8382Z",
    fill: "#B6BFCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserProfile03);
export default __webpack_public_path__ + "static/media/ic-user-profile-03.a13cca5761f05558d581e1d5fbc1c3e0.svg";
export { ForwardRef as ReactComponent };